import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { ReplacePatientTermPipe, SanitizeHtmlPipe } from '../filter-section.pipe';
import { SharedDataService } from 'src/services/shared-data.service';
import { ResponseService } from 'src/services/response.service';
import { FormsModule } from '@angular/forms';
import { combineLatest, debounceTime, forkJoin, fromEvent, of, tap, throwError } from 'rxjs';
import { ResponseText, ResponseTypes } from 'src/models/app-enums.model';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { QuestionnaireResponseAnswer, QuestionnaireResponseQuestion } from 'src/models/questionnaire-response.model';
import { ResponseAnswerUpdateRequest } from 'src/models/response.model';
import { DateUtil } from 'src/app/shared/utils/date.util';

@Component({
  selector: 'app-radio-button-horizontal',
  templateUrl: './radio-button-horizontal.component.html',
  styleUrls: ['./radio-button-horizontal.component.scss'],
  standalone: true,
imports: [MaterialModule, CommonModule, FormsModule, ReplacePatientTermPipe, SanitizeHtmlPipe]
})
export class RadioButtonHorizontalComponent implements OnInit, AfterViewInit {

  @Input() questions!: QuestionnaireResponseQuestion[];
  @Input() index!: number;

  questionsWithSharedHeader: QuestionnaireResponseQuestion[] = []

  ResponseTypesEnum = ResponseTypes;

  patientTerm!: string;
  isPreview: boolean = false
  isPhonePortrait: boolean = false;

  constructor(
    private _sharedDataService: SharedDataService, 
    private _responseService: ResponseService,
    private _responsive: BreakpointObserver
  ) {}

  /**
   * 
   */
  ngOnInit(): void {

    this.questionsWithSharedHeader.push(this.questions[this.index++])
    while(this.index < this.questions.length && this.questions[this.index].responseType === this.ResponseTypesEnum.RadioButtonHorizontalWithoutHeader) {
      this.questionsWithSharedHeader.push(this.questions[this.index++])
    }
    
    // screen size
    this._responsive.observe([Breakpoints.Small, Breakpoints.HandsetPortrait]).subscribe(result => {
      this.isPhonePortrait = false;
      if (result.matches) {
        this.isPhonePortrait = true;
      }
    });
    // read global patient term and preview mode
    combineLatest([this._sharedDataService.previewMode$, this._sharedDataService.patientTerm$])
      .subscribe(([isPreview, patientTerm]) => {
        this.isPreview = isPreview
        this.patientTerm = patientTerm
      }
    )
  }

  ngAfterViewInit(): void {
    setTimeout(()=>{
      let inputAr = document.getElementsByTagName("input");
      
      for(let i=0;i<inputAr.length;i++){
        if(inputAr[i].getAttribute("type")?.toLowerCase()=="radio"){
          //logic addded to check whether the input has adjacent label and stop the execution
          let executeFlag = false;
          let parentDiv = (<HTMLDivElement>(inputAr[i]?.parentNode));
          if(parentDiv?.getElementsByTagName('label').length>0){
            executeFlag = true;
          }
          if(!executeFlag){
            let lbl = inputAr[i].getAttribute("id") || "";
            let lblVl = (lbl.split(" ").join(""))+'-'+i;
            
            inputAr[i].removeAttribute("tabindex");
            inputAr[i].setAttribute("aria-labelledby", lblVl);
            inputAr[i].id = lblVl;
              
            
            let lblElm = document.createElement('label');
            lblElm.setAttribute("for", lblVl);
            lblElm.setAttribute("class","hidden");
            let textVal = document.createTextNode("radio"+i);
            lblElm.appendChild(textVal);
            inputAr[i].insertAdjacentElement("beforebegin", lblElm);
          }
        }
      }
      try{
        let lblEls = document.getElementsByClassName('mdc-label');
        let len = lblEls.length-1;
        while(len>=0){
          if(lblEls[len].getElementsByTagName("*").length>0){
            let childNode = lblEls[len].getElementsByTagName("*")[0];
            const copyNode = childNode.cloneNode(true);
            lblEls[len].parentNode?.appendChild(copyNode);
          }
          lblEls[len].remove();
          len--;
        }
      }catch(e){
        console.log(e)
      }
    },1000);
  }

  /**
   * Save selection
   * @param selectedAnswer 
   */
  saveSelection(question: QuestionnaireResponseQuestion, selectedAnswer: QuestionnaireResponseAnswer) {
    const selectedAnswerTemp = question.answers.find(ans => ans.answerId === selectedAnswer.answerId)
    if(selectedAnswerTemp === undefined) {
      throw throwError('Answer was not found')
    }
    
    const responseAnswerUpdateRequest : ResponseAnswerUpdateRequest = {
      responseId: this._sharedDataService.questionnaireResponse!.responseId,
      question: {
        questionId: question.questionId,
        responseText: question.responseText,
        answers: [
          {
            ...selectedAnswerTemp,
            selected: true,
            responseTimestamp: DateUtil.toISOString(new Date())
          }
        ]
      },
      isPreview: this.isPreview
    }

    this._responseService.updateSingleAnswerForResponse(responseAnswerUpdateRequest).subscribe(() => {
        // update global questions
        question.answers = question.answers.map(ans => {
          ans.selected = ans.answerId === selectedAnswerTemp.answerId
          return ans
        })
        question.isAnswered = true;
    })
  }
}